import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import DocumentLink from '../../DocumentLink';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class Manual extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"politica-gov-corporativa"} page={'politica-gov-corporativa'}></InfoComponent>

					{/* Content page */}
					<div className="_the-content">
						<div className="container">
							<div className="row justify-content-center">

								<div className="col-md-10">
									<div className="row">

										<ErrorBoundary><DocumentLink    fileImg={'../../assets/img/Manual de Governança_Prancheta 1.png'} url={'ObterManualGovernanca'} /></ErrorBoundary>

									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
			<ErrorBoundary>	<Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Manual;